import { CONVERSATION_ITEM_MEMBER, USER_BATCH } from '@/config/api/api-routes';
import type { User } from '@/features/participant';
import { http } from '@/shared/api/http';
import type { ResultApi } from '@/shared/types/result-api';
import { Member } from '../models/member';
import type { MemberDeleteRes, MemberListRes } from '../models/member-dto';

export const getUserByIds = async (userIds: string[], includeProfiles = true): Promise<User[]> => {
  const response = await http.post<ResultApi<User[]>>(USER_BATCH, { userIds, includeProfiles });
  if (!response.data.data) throw new Error('Failed to search users');
  return response.data.data;
};

export const deleteMembers = async (conversationId: string, userIds: string[]): Promise<MemberDeleteRes> => {
  const response = await http.delete<ResultApi<MemberDeleteRes>>(
    CONVERSATION_ITEM_MEMBER.replace(':conversationId', conversationId),
    {
      data: { userIds }
    }
  );

  if (!response.data.data) {
    throw new Error('Failed to delete members');
  }

  return response.data.data;
};

export const getMembers = async (convId: string): Promise<Member[]> => {
  const response = await http.get<ResultApi<MemberListRes>>(
    CONVERSATION_ITEM_MEMBER.replace(':conversationId', convId),
    {
      params: {
        PageNumber: 1,
        PageSize: 100,
        useCache: false
      }
    }
  );

  if (!response.data.data) throw new Error('Failed to search users');
  const userIds = response.data.data.members.map((m) => m.userId);
  const users = await getUserByIds(userIds, true);

  return response.data.data.members.map((member) => {
    const user = users.find((u) => u.id === member.userId);
    return new Member({ ...member, user });
  });
};
